import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {PageLinksListComponent} from './page-links-list/page-links-list.component';
import {RouterModule} from '@angular/router';
import {TranslateModule} from '@ngx-translate/core';
import { FormLinksComponent } from './form-links/form-links.component';
import {PipesModule} from "@inspark/inspark-components";
import {FilterByPipe} from '../../../../../projects/common/standalone/pipes/filter-by.pipe';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    TranslateModule,
    PipesModule,
    FilterByPipe
  ],
  declarations: [PageLinksListComponent, FormLinksComponent],
  exports: [PageLinksListComponent, FormLinksComponent]
})
export class PageLinksModule {
}
